<template>
  <div>
    <el-aside class="main-container-side" width="344px">
      <div class="search">
        <el-input
          placeholder="输入搜索名词/编码"
          v-model="advSearchForm.searchText"
          @keyup.enter.native="search"
          @input="handleInputSearch"
          autocomplete="off"
          maxlength="50"
          class="search-input"
          clearable
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            class="search-btn"
            size="mini"
            @click="search"
          ></el-button>
        </el-input>
        <div class="adv-switch">
          <el-button
            type="text"
            size="mini"
            class="exp-col"
            @click="expColAdvSearch"
            >{{ advSearchBeh }}检索</el-button
          >
        </div>
      </div>
      <div id="advSearch" class="adv-search" v-show="isShowAdvSearch">
        <el-form ref="advSearchForm" :model="advSearchForm">
          <el-row style="margin-bottom:4px">
            <el-col :span="13">
              <el-select
                v-model="advSearchForm.departmentId"
                placeholder="选择科室"
                class="select-input ks-select"
                clearable
                filterable
                size="mini"
                @change="handleSearchInputChange('department')"
              >
                <el-option
                  v-for="item in deptOpts"
                  :label="item.label"
                  :value="item.id"
                  :key="item.id + item.label"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="1" style="height:32px;"></el-col>
            <el-col :span="10">
              <el-select
                v-model="advSearchForm.confirmed"
                placeholder="是否新增"
                class="select-input check-select"
                clearable
                filterable
                size="mini"
                @change="handleSearchInputChange"
              >
                <el-option
                  v-for="item in confirmedOpts"
                  :label="item.label"
                  :value="item.value"
                  :key="item.value + item.label"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-form-item prop="categoryId">
            <el-select
              v-model="advSearchForm.categoryId"
              placeholder="选择名词类型"
              class="select-input type-select"
              clearable
              filterable
              size="mini"
              style="width:100%"
              @change="handleSearchInputChange('category')"
            >
              <el-option
                v-for="item in categoryOpts"
                :label="item.label"
                :value="item.id"
                :key="item.id + item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="sourceId">
            <el-select
              v-model="advSearchForm.sourceId"
              placeholder="选择名词来源"
              class="select-input type-select"
              clearable
              filterable
              size="mini"
              style="width:100%"
              @change="handleSearchInputChange('source')"
            >
              <el-option
                v-for="item in sourcesOpts"
                :label="item.label"
                :value="item.id"
                :key="item.id + item.label"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div
        class="leftNav"
        ref="leftNav"
        :style="navHeight"
        v-loading.lock="loading"
        element-loading-text="搜索中..."
      >
        <!--                <el-scrollbar style="height:100%"  >-->
        <el-tree
          id="tree1"
          :props="defaultProps"
          node-key="id"
          :load="loadNode"
          accordion
          lazy
          icon-class="el-icon-arrow-right"
          ref="tree"
          highlight-current
          @node-click="handleNodeClick"
          @node-collapse="handleNodeCollapseClick"
          v-show="!searching"
          @node-expand="handleNodeExpandClick"
        >
          <span
            class="custom--node"
            :class="{ 'node-level3': node.level == 3 }"
            slot-scope="{ node, data }"
            style="outline: none;"
          >
            <span
              :tabindex="data.id"
              :title="node.label"
              class="node-span"
              :class="{ [`node-${data.id}`]: node.level == 3 }"
              style="outline: none;"
              >{{ node.label
              }}<i
                class="unconfirmed"
                v-if="node.level == 3 && !data.confirmed"
              ></i
            ></span>
          </span>
        </el-tree>
        <!-- v-show="advSearchForm.searchText != '' && searching" -->
        <el-tree
          id="tree2"
          class="filter-tree"
          :data="searchResult"
          :props="defaultProps"
          @node-click="handleNodeClick"
          highlight-current
          default-expand-all
          @node-expand="handleNodeExpandClick"
          v-show="searching"
        >
          <span
            class="custom-tree-node"
            :class="{ 'node-level3': node.level == 3 }"
            slot-scope="{ node, data }"
            style="outline: none;"
          >
            <span
              :title="node.label"
              class="keyword"
              v-html="keyRegExp(node)"
              style="outline: none;"
            >
            </span>
            <i
              class="unconfirmed"
              v-if="node.level == 3 && !data.confirmed"
            ></i>
          </span>
        </el-tree>

        <!--                </el-scrollbar>-->
      </div>

      <div id="list-shortcut" class="list-shortcut" v-show="shortcutVisible">
        <ul>
          <li
            v-for="(val, index) in shortcutObj"
            class="item"
            :data-index="index"
            :key="val"
            @click="onShortcutStart($event)"
            :class="{ current: currentIndex == index }"
          >
            {{ index }}
          </li>
        </ul>
      </div>
    </el-aside>
  </div>
</template>

<script>
// import axios from '../lib/http'
import { allEmptyKey, debounce } from '@/lib/utils'
import homeApi from '../api/home'
import termManageDataApi from '@/api/termManageData'
export default {
  name: 'LeftMenu',
  data() {
    return {
      searchResult: [],
      searching: false,
      shortcutObj: {},
      defaultProps: {
        label: 'label',
        children: 'children',
        isLeaf: 'leaf',
      },
      count: 1,
      currentIndex: 0,
      clientHeight: '',
      navHeight: {
        height: '',
      },
      loading: false,
      shortcutVisible: false,
      // 是否显示高级搜索面板
      isShowAdvSearch: false,
      // 高级搜索表单
      advSearchForm: {
        searchText: '',
        departmentId: '',
        confirmed: '',
        categoryId: '',
        sourceId: '',
      },
      deptOpts: [],
      confirmedOpts: [
        {
          label: '全部',
          value: 'all',
        },
        {
          label: '《常用临床医学名词》',
          value: true,
        },
        {
          label: '医院新增名词',
          value: false,
        },
      ],
      categoryOpts: [{ id: 'all', label: '全部' }],
      sourcesOpts: [],
      // 树形展示节点是否全部展开标识
      // defaultExpand: false,
      node_in_loadNode: [], // 保存loadNode中的node
      resolve_in_loadNode: [], // 保存loadNode中的resolve
    }
  },
  computed: {
    advSearchBeh() {
      return this.isShowAdvSearch ? '收起' : '展开'
    },
  },
  watch: {
    'advSearchForm.searchText'(val) {
      if (val == '') {
        this.searching = false
        this.shortcutVisible = true
      }
    },
    // 如果 `clientHeight` 发生改变，这个函数就会运行
    clientHeight: function(val) {
      this.changeFixed(val)
    },
  },
  methods: {
    // 清空搜索条件
    clearAdvSearch() {
      this.advSearchForm = {
        searchText: '',
        departmentId: '',
        confirmed: '',
        categoryId: '',
        sourceId: '',
      }
    },
    // 收起或者展开全部树节点
    expColTree(val) {
      // 所有3层节点对象
      let nodes = this.$refs.tree.store._getAllNodes()
      // console.log('nn nodes:', nodes)
      // 3层节点长度
      let length = nodes.length
      for (let i = 0; i < length; i++) {
        nodes[i].expanded = val
      }
      // 收缩2层节点
      if (nodes[0] && nodes[0].parent) {
        nodes[0].parent.expanded = val
      }
      // 收缩1层节点
      if (nodes[0] && nodes[0].parent && nodes[0].parent.parent) {
        nodes[0].parent.parent.expanded = val
      }
    },
    // 重新加载树状菜单
    reloadNode() {
      this.node_in_loadNode.childNodes = [] //把存起来的node的子节点清空，不然会界面会出现重复树
      this.loadNode(this.node_in_loadNode, this.resolve_in_loadNode) //再次执行懒加载的方法
    },
    // 切换展示高级搜索面板
    expColAdvSearch() {
      this.isShowAdvSearch = !this.isShowAdvSearch
      let shortCutDom = document.querySelector('#list-shortcut')
      // 展开搜索，字母索引增加高度
      if (this.isShowAdvSearch) {
        shortCutDom.style.top = '288px'
      } else {
        // 收缩搜索，字母索引减少高度
        shortCutDom.style.top = '153px'
      }
    },
    async loadDepartmentList() {
      let deptOpts = sessionStorage.getItem('-_deptOpts_-')
      if (deptOpts) {
        this.deptOpts = JSON.parse(deptOpts)
        return
      }
      try {
        let res = await homeApi.getDepartmentsList()
        if (res.success) {
          this.deptOpts = res.data
          this.deptOpts.splice(0, 0, { id: 'all', label: '全部' })
          sessionStorage.setItem('-_deptOpts_-', JSON.stringify(this.deptOpts))
        } else {
          this.$message.error(res.message)
        }
      } catch (err) {
        console.log(err)
      }
    },
    async loadCategoryList(id, type) {
      if (!type) {
        this.categoryOpts = [{ id: 'all', label: '全部' }]
      }
      if (!id) {
        return
      }
      let categoryOpts = sessionStorage.getItem('-_categoryOpts_-')
      if (categoryOpts) {
        let cache = JSON.parse(categoryOpts)
        if (cache[id] && cache[id].length > 0) {
          if (!type) {
            this.categoryOpts = cache[id]
            return
          }

          return cache[id]
        }
      }
      try {
        let res = await homeApi.getDepartmentsInfo(id, false)
        if (res.success) {
          if (res.data && res.data.category) {
            if (!type) {
              this.categoryOpts = res.data.category
            }
            let cache = {}
            let categoryOpts = sessionStorage.getItem('-_categoryOpts_-')
            if (categoryOpts) {
              cache = JSON.parse(categoryOpts)
            }
            cache[id] = res.data.category
            cache[id].splice(0, 0, { id: 'all', label: '全部' })
            sessionStorage.setItem('-_categoryOpts_-', JSON.stringify(cache))
            return cache[id]
          }
        } else {
          this.$message.error(res.message)
        }
      } catch (err) {
        console.log(err)
      }
    },
    async getSourcesList() {
      let res = await termManageDataApi.getSourcesList()
      if (res.success) {
        this.sourcesOpts = res.data
        this.sourcesOpts.splice(0, 0, { id: 'all', label: '全部' })
      } else {
        this.$message.error(res.message)
      }
    },
    async handleSearchInputChange(type) {
      if (type && type === 'department') {
        this.advSearchForm.categoryId = ''
        this.categoryOpts = [{ id: 'all', label: '全部' }]
        if (this.advSearchForm.departmentId !== 'all') {
          await this.loadCategoryList(this.advSearchForm.departmentId)
        }
      }
      // if (allEmptyKey(this.advSearchForm)) {
      //   this.searching = false
      //   // 收起所有节点
      //   // this.reloadNode()
      //   this.expColTree(false)
      // } else {
      //   this.search()
      // }
      this.search()
    },
    keyRegExp(node) {
      // if(node.level>2){
      //  console.log(node)
      let val = node.label
      let searchText = this.advSearchForm.searchText
      let searchStrReg = searchText
        .trim()
        .split(/\s+/)
        .join('|')
      let regStr = `(${searchStrReg})`
      val = val.replace(
        new RegExp(regStr, 'g'),
        '<span style="color: #f00;">$1</span>'
      )
      return val
    },
    handleInputSearch: debounce(function(e) {
      // if (allEmptyKey(this.advSearchForm)) {
      //   this.searching = false
      //   // 收起所有节点
      //   // this.reloadNode()
      //   this.expColTree(false)
      // } else {
      //   this.search()
      // }
      this.search()
    },1000),
    async search() {
      // if (this.advSearchForm.searchText == '') {
      //   this.$message.warning('请输入搜索名词/编码')
      //   return
      // }
      if (allEmptyKey(this.advSearchForm)) {
        this.searching = false
        this.$message.warning('请输入搜索条件')
        return
      }
      // if (allEmptyKey(this.advSearchForm)) {
      //   this.reloadNode()
      //   return
      // }
      this.shortcutVisible = false
      this.searching = true
      this.$nextTick(() => {
        this.loading = true
      })
      this.loading = true
      // console.log('search...')
      let keyword = this.advSearchForm.searchText
      let departmentId = this.advSearchForm.departmentId
      let categoryId = this.advSearchForm.categoryId
      let confirmed = this.advSearchForm.confirmed
      let sourceId = this.advSearchForm.sourceId
      let param = {
        keyword,
        departmentId: departmentId === 'all' ? null : departmentId,
        categoryId: categoryId === 'all' ? null : categoryId,
        confirmed: confirmed === 'all' ? null : confirmed,
        sourceId: sourceId === 'all' ? null : sourceId,
      }
      // let data =await axios.post('/api/csbd/search',param)
      let data = await homeApi.searchList(param)
      if (data.success) {
        data = data.data
      } else {
        data = []
      }
      this.loading = false
      // console.log(data)
      data = data.map((item) => {
        item.children = item.category
        return item
      })
      // console.log(data)
      this.searchResult = data
    },
    async loadNode(node, resolve) {
      console.log('loadNode:')
      console.log(node.level)
      if (node.level === 0) {
        // let data1 = await axios.get('/api/csbd/departments');
        let data1 = await homeApi.getDepartmentsList()
        this.node_in_loadNode = node //这里是关键！在data里面定义一个变量，将node.level == 0的node存起来
        this.resolve_in_loadNode = resolve //同上，把node.level == 0的resolve也存起来
        console.log(data1)
        if (data1.success) {
          return resolve(data1.data)
        } else {
          this.$message.error(data1.message)
          return
        }
      }
      if (node.level === 1) {
        // let data2 =[{"id":1,"label":"疾病诊断名词","childrenCount":3582},{"id":2,"label":"症状体征名词","childrenCount":108},{"id":3,"label":"手术操作名词","childrenCount":355},{"id":4,"label":"临床检查名词","childrenCount":84}]
        // let data2 = await axios.get('/api/csbd/departments/'+node.data.id+'/info');
        let data2 = await homeApi.getDepartmentsInfo(node.data.id)
        if (data2.success) {
          return resolve(data2.data.category)
        } else {
          this.$message.error(data2.message)
          return
        }
      }
      if (node.level === 2) {
        this.shortcutVisible = true
        let data3 = await homeApi.getCategoryList(node.data.id)
        if (data3.success) {
          let data3Nodes = data3.data
          data3Nodes = data3Nodes.map((item) => {
            item.leaf = true
            return item
          })
          let shortcutObj = {}
          data3Nodes.map((item) => {
            if (!shortcutObj.hasOwnProperty(item.index.substr(0, 1))) {
              shortcutObj[item.index.substr(0, 1)] = item.id
            }
          })
          this.shortcutObj = shortcutObj
          // this.shortcutList = Array.from(new Set(this.shortcutList))
          return resolve(data3Nodes)
        } else {
          this.$message.error(data3.message)
          return
        }
      }
    },
    handleNodeExpandClick(data, node) {
      console.log('handleNodeExpandClick:')
      if (node.level == 1) {
        this.$router.push('/department/' + data.id)
        this.shortcutVisible = false
        node.childNodes.map((nodeObj) => {
          //是否有展开的树
          if (nodeObj.expanded) {
            console.log(nodeObj)
            // 拿到新的索引数组
            let shortcutObj = {}
            nodeObj.childNodes.map((node) => {
              let item = node.data
              if (!shortcutObj.hasOwnProperty(item.index.substr(0, 1))) {
                shortcutObj[item.index.substr(0, 1)] = item.id
              }
            })
            if (!this.searching) {
              this.shortcutObj = shortcutObj
              this.shortcutVisible = true
            }
          }
        })
      }
      if (node.level == 2) {
        // console.log(node.childNodes);
        //console.log(node);//可拿到层级
        //console.log(compoent);//可拿到层级
        let shortCutDom = document.querySelector('#list-shortcut')
        if (this.isShowAdvSearch) {
          shortCutDom.style.top = '288px'
        } else {
          // 收缩搜索，字母索引减少高度
          shortCutDom.style.top = '153px'
        }
        if (node.childNodes.length > 0) {
          // 拿到新的索引数组
          let shortcutObj = {}
          node.childNodes.map((nodeObj) => {
            let item = nodeObj.data
            if (!shortcutObj.hasOwnProperty(item.index.substr(0, 1))) {
              shortcutObj[item.index.substr(0, 1)] = item.id
            }
          })
          //搜索时不展示索引
          if (!this.searching) {
            this.shortcutObj = shortcutObj
            this.shortcutVisible = true
          }
        }
      }
    },
    handleNodeCollapseClick() {
      console.log('handleNodeCollapseClick:')
      this.shortcutVisible = false
      this.shortcutObj = {}
    },
    handleNodeClick(data, node) {
      console.log('handleNodeClick:')
      if (node.level == 1) {
        this.$router.push('/department/' + data.id)
      }
      if (node.level == 3) {
        // this.$router.push('/terminology/'+data.id)
        //埋点统计：拿到浏览次数（PV）：每点击一次词条，PV计数+1
        homeApi.pvRecord()
        const routerPath = '/terminology/' + data.id
        this.$router.push({
          path: routerPath,
          query: {
            t: +new Date(),
          },
        })
      }
    },
    onShortcutStart(e) {
      let index = e.target.getAttribute('data-index')
      this.currentIndex = index
      let id = this.shortcutObj[index]
      let node = document.querySelector('.node-' + id)
      node.focus()
    },
    changeFixed(v) {
      //动态修改样式
      this.navHeight.height = Number(v) - 150 + 'px'
    },
    initHeight() {
      //获取高度
      //获取浏览器可视区域高度
      this.clientHeight =
        document.documentElement.clientHeight || document.body.clientHeight
      window.onresize = () => {
        //当窗口或框架发生改变时触发
        this.clientHeight =
          document.documentElement.clientHeight || document.body.clientHeight
      }
    },
  },

  mounted() {
    // console.log('nn leftMenu mounted')
    this.initHeight()
    // 拉取科室下拉列表
    this.loadDepartmentList()
    // 拉取名词来源下拉列表
    this.getSourcesList()
    // this.$watch(
    //   'advSearchForm.searchText',
    //   debounce((payload) => {
    //     if (allEmptyKey(this.advSearchForm)) {
    //       this.searching = false
    //     } else {
    //       this.search()
    //     }
    //   }, 500)
    // )
  },
  activated() {
    let needReload = JSON.parse(sessionStorage.getItem('needReload'))
    if (needReload) {
      window.location.reload()
      needReload = false
      sessionStorage.setItem('needReload', JSON.stringify(needReload))
    }
    // console.log('nn leftMenu activated')
    // 清空搜索条件
    this.clearAdvSearch()
    // 隐藏搜索树
    this.searching = false
    // 收起展示树
    this.expColTree(false)
  },
  // beforeDestroy() {
  //   this.reloadNode()
  // },
}
</script>
<style lang="less">
.el-message-box__btns {
  .contact-confirm {
    background-color: #1daaba !important;
    border-color: #1daaba !important;
  }
}
.main-container-side {
  /*.el-scrollbar .el-scrollbar__wrap {overflow-x: hidden;}*/
  .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 9px;
  }
  .el-button--mini,
  .el-button--mini.is-round {
    /*padding: ;*/
    padding: 0 20px;
  }
  .el-tree > .el-tree-node {
    min-width: 100%;
    display: inline-block;
    width: 230px;
  }
  .el-tree-node > .el-tree-node_children {
    overflow: visible;
  }
  .el-tree-node__expand-icon.is-leaf {
    display: none;
  }

  .node-level3 {
    margin-left: 4px;
    width: 188px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block;
  }
  .node-span:focus {
    background-color: #f0f2f5;
  }
  .el-submenu__title {
    font-size: 18px;
    letter-spacing: 2px;
  }

  .el-submenu__title:hover {
  }

  .el-icon-arrow-down:before {
    content: '';
  }

  .el-input .el-input__clear {
    line-height: 32px;
  }

  .el-input__inner {
    height: 32px;
    line-height: 32px;
  }
  .el-input-group__append {
    border-left: 0;
    background: #1daaba;
    color: #fff;
  }
  .el-input-group__append:hover {
    background-color: #6bc3c7;
    color: #fff;
  }

  .el-tree-node__content {
    border-bottom: 1px solid #dcdfe6;
  }
  .el-tree--highlight-current
    .el-tree-node.is-current
    > .el-tree-node__content {
    background-color: transparent;
    color: #1daaba;
    outline: none;
  }
  .el-tree--highlight-current
    .el-tree-node.is-current
    > .el-tree-node__content
    .node-span {
    background-color: #f0f2f5;
  }
}
</style>
<style scoped lang="less">
.search {
  // margin-bottom: 20px;
  .search-input {
  }
  .adv-switch {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .exp-col {
      padding-right: 0;
      padding-top: 8px;
      padding-bottom: 8px;
      color: #3ab5c9;
      font-size: 12px;
    }
  }
}
.adv-search {
  box-shadow: 0px 0px 4px 0px rgba(58, 181, 201, 0.4);
  border-radius: 4px;
  margin-bottom: 8px;
  box-sizing: border-box;
  padding: 6px;
  .el-form-item {
    margin-bottom: 1px;
  }
}
.main-container-side {
  background: rgba(255, 255, 255, 1);
  font-size: 14px;
  margin-right: 10px;
  padding-top: 24px;
  padding-left: 34px;
  padding-right: 34px;
  width: 344px;
  height: 100%;
  .leftNav {
    width: 236px;
    i.unconfirmed {
      display: inline-block;
      position: relative;
      top: 1px;
      width: 12px;
      height: 12px;
      background-image: url('../assets/img/unconfirm.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      margin-left: 8px;
    }
  }
  //点击后右箭头的反转效果
  .nav-n-box-active {
    .right-btn {
      transform: rotate(90deg) !important;
    }
  }

  .list-shortcut {
    position: absolute;
    z-index: 30;
    left: 317px;
    top: 153px;
    width: 20px;
    text-align: center;
    /*background-color: #f5f5f5;*/
    ul,
    li {
      list-style: none;
      width: 20px;
      margin: 0;
      padding: 0;
    }
    .item {
      padding: 3px;
      line-height: 1;
      color: black;
      font-size: 11px;
      margin-left: -3px;
      cursor: pointer;
      /*&.current {*/
      /*    color: rgb(45,132,222);*/
      /*}*/
    }
  }
}
</style>
